export default {
  // add any qatar specific strings here or to override base strings
  en: {
    qatar: 'Qatar',
    fullCartRedemption: 'Congratulations! Your grand total will be covered using MyCLUB Points',
    loyaltyPoints: 'MyCLUB Pts.',
    orderSummaryPointsEarned: "MyCLUB points you'll earn with this order",
    orderSummaryShareDiscount: 'Paid by MyCLUB points',
    points: 'MyCLUB Points',
    redeemPoints: 'Redeem',
    shareDiscount: 'Use your MyCLUB points',
    addCardDetails: 'Add new Credit Card',
    bankRedirection: 'Click "Place Order" to proceed with the payment',
    creditDebitCard: 'Credit Card',
    debitCard: 'Debit Card',
  },
  ar: {
    qatar: 'نعم',
    fullCartRedemption: 'تهانينا! سيتم تغطية المبلغ الإجمالي باستخدام نقاط ماي كلوب',
    loyaltyPoints: 'نقاط ماي كلوب',
    orderSummaryPointsEarned: 'التي ستكسبها من هذا الطلب MyCLUB عدد نقاط',
    orderSummaryShareDiscount: 'تم الدفع بنقاط ماي كلوب',
    points: 'نقاط ماي كلوب',
    redeemPoints: 'استبدال',
    shareDiscount: 'رصيد نقاط ماي كلوب',
    addCardDetails: 'أضف بطاقة ائتمان جديدة',
    bankRedirection: 'اضغط على "اجراء الطلب" للذهاب إلى صفحة الدفع',
    creditDebitCard: 'بطاقة الائتمان',
    debitCard: 'بطاقة السحب المباشر',
  },
};
